import script from "./McpSetupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./McpSetupDialog.vue?vue&type=script&setup=true&lang=js"

import "./McpSetupDialog.vue?vue&type=style&index=0&id=34c1eba9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34c1eba9"]])

export default __exports__